import { render } from "./UiPropCheckbox.vue?vue&type=template&id=091fd3ba"
import script from "./UiPropCheckbox.vue?vue&type=script&lang=js"
export * from "./UiPropCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__